import styled from 'styled-components'

export const DropdownMenuIcon = styled.span`
  margin-left: 15px;
  margin-top: 6px;
`

DropdownMenuIcon.displayName = 'DropdownMenuIcon'
